<script setup lang="ts">
/** Appendix A/B 공통 — BO 인적사항 표. keyPrefix 로 문서별 필드 분리. */
import BoAppendixDocVarField from '../BoAppendixDocVarField.vue';

const props = withDefaults(defineProps<{ keyPrefix?: string }>(), { keyPrefix: '' });
function k(base: string) { return `${props.keyPrefix || ''}${base}`; }
</script>

<template>
  <table class="cdd-tbl bo-part-tbl">
    <thead>
      <tr>
        <th class="col-no">NO</th>
        <th>DETAILS OF THE BENEFICIAL OWNER</th>
      </tr>
    </thead>
    <tbody>
      <tr><td class="cdd-lcell">1</td><td>Full name: <BoAppendixDocVarField :field-key="k('bo_full_name')" /></td></tr>
      <tr><td class="cdd-lcell">2</td><td>Address of usual place of residence: <BoAppendixDocVarField :field-key="k('bo_residential_address')" /></td></tr>
      <tr><td class="cdd-lcell">3</td><td>Business Address, if any: <BoAppendixDocVarField :field-key="k('bo_business_address')" /></td></tr>
      <tr><td class="cdd-lcell">4</td><td>Email address, if any: <BoAppendixDocVarField :field-key="k('bo_email')" /></td></tr>
      <tr><td class="cdd-lcell">5</td><td>Nationality: <BoAppendixDocVarField :field-key="k('bo_nationality')" /></td></tr>
      <tr><td class="cdd-lcell">6</td><td>Date of Birth: <BoAppendixDocVarField :field-key="k('bo_dob')" /></td></tr>
      <tr><td class="cdd-lcell">7</td><td>Race: <BoAppendixDocVarField :field-key="k('bo_race')" /></td></tr>
      <tr><td class="cdd-lcell">8</td><td>Gender: <BoAppendixDocVarField :field-key="k('bo_gender')" /></td></tr>
      <tr><td class="cdd-lcell">9</td><td>NRIC/Passport No.: <BoAppendixDocVarField :field-key="k('bo_id_no')" /></td></tr>
      <tr><td class="cdd-lcell">10</td><td>Contact No.: <BoAppendixDocVarField :field-key="k('bo_contact_no')" /></td></tr>
      <tr><td class="cdd-lcell">11</td><td>To state position in the company, if applicable: <BoAppendixDocVarField :field-key="k('bo_position')" /></td></tr>
      <tr><td class="cdd-lcell">12</td><td>The date becoming a beneficial owner: <BoAppendixDocVarField :field-key="k('bo_date_became')" /></td></tr>
    </tbody>
  </table>
</template>

<style scoped>
.bo-part-tbl { table-layout: fixed; width: 100%; }
.bo-part-tbl .col-no { width: 36px; }
.bo-part-tbl td, .bo-part-tbl th { word-break: break-word; overflow-wrap: anywhere; }
.bo-part-tbl .cdd-lcell { width: 36px; text-align: center; }
</style>
